import { render, staticRenderFns } from "./AddOffer.vue?vue&type=template&id=0b37784f&scoped=true"
import script from "./AddOffer.vue?vue&type=script&lang=js"
export * from "./AddOffer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b37784f",
  null
  
)

export default component.exports